import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse, Profile } from '@/types'

export const fetchProfile = async (userId: string): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`/profile/${userId}`)
    resp.data = response.data.data
    // transform string to object.
    // see https://github.com/jobscanco/jobscan/pull/6990
    if (
      resp.data.educationInfo &&
      typeof resp.data.educationInfo === 'string'
    ) {
      resp.data.educationInfo = JSON.parse(resp.data.educationInfo)
    }
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const updateProfile = async (
  userId: string,
  profileData: Profile
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.patch(`/profile/${userId}`, profileData)
    resp.data = response.data.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
